export const contactInfo = [
  {
    text: "LinkedIn",
    link: "https://www.linkedin.com/in/ramonaudain/",
  },
  // {
  //   text: "Twitter",
  //   link: "https://twitter.com/ramonaudain",
  // },
  {
    text: "GitHub",
    link: "https://github.com/raaudain",
  },
];

export const projects = [
  // DevJobs
  {
    name: "DevJobs",
    projectLink: "https://devjobs-raaudain.vercel.app/",
    gitHubLink: "https://github.com/raaudain/devjobs-frontend",
    tech: "JavaScript, Bootstrap 5, CSS, Python, Requests, BeautifulSoup4, Selenium",
    description: "A job board aggregator for people working in software development and engineering, DevOps, and IT. The purpose of this application is to make job searching a little easier.",
    image: "/assets/img/projects/devjobs.png",
  },
  // Sauti Marketplace
  {
    name: "Sauti Marketplace",
    projectLink: "https://sauti-marketplace.raaudain.vercel.app/",
    gitHubLink: "https://github.com/raaudain/sauti-marketplace",
    tech:
      "React, Redux, Axios, CSS/Less, HTML, Node.js, Express, SQLite, Knex.js, CORS, Helmet, JSON Web Token, bcrypt, Jest, Supertest",
    description: "A full stack application with form validation and authentication capabilities.",
    image: "/assets/img/projects/sauti.png",
  },
  // NASA APOD
  {
    name: "NASA APOD",
    projectLink: "https://nasa-apod.raaudain.now.sh/",
    gitHubLink: "https://github.com/raaudain/nasa-apod",
    tech: "React, Axios, CSS, HTML",
    description: "Every wondered what's going on in outer space? NASA APOD gives you a glimpse of what's going on in the universe.",
    image: "/assets/img/projects/apod.png",
  },
  // Gotta Do
  {
    name: "Gotta Do",
    projectLink: "https://gotta-do.raaudain.now.sh/",
    gitHubLink: "https://github.com/raaudain/gotta-do",
    tech: "React, CSS/Sass, HTML",
    description: "Today's world can be hectic and keeping up with all the things that need done can be a job in itself. Gotta Do is an installable web application that keeps track of all of your errands so you don't have to.",
    image: "/assets/img/projects/gotta.png",
  },
  // Tennis Game
  {
    name: "Tennis Game",
    projectLink: "https://tennis-game.raaudain.now.sh",
    gitHubLink: "https://github.com/raaudain/tennis-game",
    tech: "JavaScript, CSS, HTML",
    description: "Have time to kill? Play a clone of an arcade classic.",
    image: "/assets/img/projects/tennis.png",
  },
];
